import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const GantiPassword = ({ token }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      return Swal.fire('Gagal', 'Password baru dan konfirmasi tidak sama!', 'error');
    }

    if (newPassword.length < 6) {
        return Swal.fire('Lemah', 'Password minimal 6 karakter.', 'warning');
    }

    setLoading(true);
    try {
      // --- CARA BACA TOKEN MANUAL (TANPA INSTALL LIBRARY) ---
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      
      const user = JSON.parse(jsonPayload); 
      // ------------------------------------------------------

      await axios.put('https://sijapan.sman10fajarharapan.sch.id/api/change-password', {
        userId: user.id,
        role: user.role,
        oldPassword,
        newPassword
      }, { headers: { Authorization: `Bearer ${token}` } });

      Swal.fire('Berhasil!', 'Password telah diperbarui. Silakan login ulang.', 'success');
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');

    } catch (err) {
      console.error(err);
      Swal.fire('Gagal', err.response?.data?.message || 'Terjadi kesalahan sistem.', 'error');
    }
    setLoading(false);
  };

  return (
    <div style={{ paddingBottom: '50px', maxWidth: '600px', margin: '0 auto' }}>
      
      <div style={{ marginBottom: '25px', textAlign: 'center' }}>
        <h2 style={{ margin: 0, color: '#1e293b' }}>🔐 Ganti Password</h2>
        <p style={{ margin: '5px 0 0', color: '#64748b', fontSize: '14px' }}>
          Amankan akun Anda dengan password yang kuat.
        </p>
      </div>

      <div style={{ background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 10px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0' }}>
        <form onSubmit={handleSubmit}>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontWeight: '600', fontSize: '13px', marginBottom: '8px', color: '#334155' }}>Password Lama</label>
            <input 
              type="password" 
              value={oldPassword} 
              onChange={e => setOldPassword(e.target.value)} 
              placeholder="Masukkan password saat ini..." 
              required
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontWeight: '600', fontSize: '13px', marginBottom: '8px', color: '#334155' }}>Password Baru</label>
            <input 
              type="password" 
              value={newPassword} 
              onChange={e => setNewPassword(e.target.value)} 
              placeholder="Minimal 6 karakter" 
              required
            />
          </div>

          <div style={{ marginBottom: '30px' }}>
            <label style={{ display: 'block', fontWeight: '600', fontSize: '13px', marginBottom: '8px', color: '#334155' }}>Konfirmasi Password Baru</label>
            <input 
              type="password" 
              value={confirmPassword} 
              onChange={e => setConfirmPassword(e.target.value)} 
              placeholder="Ulangi password baru..." 
              required
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            style={{ width: '100%', padding: '14px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '15px' }}
          >
            {loading ? 'Memproses...' : 'Simpan Password Baru'}
          </button>

        </form>
      </div>
    </div>
  );
};

export default GantiPassword;